import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class BillComparisonFormVm {
	id: number;
	providerCompanyId: number;
	customerCharge: number;
	baseRate1000KWH: number;
	baseRate1200KWH: number;
	baseRate2500KWH: number;
	baseRate750KWH: number;
	baseRate1500KWH: number;
	baseRate30KW6000KWH: number;
	baseRate40KW10000KWH: number;
	baseRate75KW15000KWH: number;
	baseRate75KW30000KWH: number;
	baseRate150KW30000KWH: number;
	baseRate150KW60000KWH: number;
	baseRate300KW60000KWH: number;
	baseRate300KW1200000KWH: number;
	baseRate500KW100000KWH: number;
	baseRate500KW200000KWH: number;
	fuelAdj1000KWH: number;
	fuelAdj1200KWH: number;
	fuelAdj2500KWH: number;
	fuelAdj750KWH: number;
	fuelAdj1500KWH: number;
	fuelAdj30KW6000KWH: number;
	fuelAdj40KW10000KWH: number;
	fuelAdj75KW15000KWH: number;
	fuelAdj75KW30000KWH: number;
	fuelAdj150KW30000KWH: number;
	fuelAdj150KW60000KWH: number;
	fuelAdj300KW60000KWH: number;
	fuelAdj300KW1200000KWH: number;
	fuelAdj500KW100000KWH: number;
	fuelAdj500KW200000KWH: number;
	stormHardening1000KWH: number;
	stormHardening1200KWH: number;
	stormHardening2500KWH: number;
	stormHardening750KWH: number;
	stormHardening1500KWH: number;
	stormHardening30KW6000KWH: number;
	stormHardening40KW10000KWH: number;
	stormHardening75KW15000KWH: number;
	stormHardening75KW30000KWH: number;
	stormHardening150KW30000KWH: number;
	stormHardening150KW60000KWH: number;
	stormHardening300KW60000KWH: number;
	stormHardening300KW1200000KWH: number;
	stormHardening500KW100000KWH: number;
	stormHardening500KW200000KWH: number;
	canEdit: boolean;
	yearMonth?: string;
	utilityProvider?: string;
	submittedBy?: string;
	userEmail?: string;
	isInvestorOwned: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'providerCompanyId': new UntypedFormControl(0, [...(validators['providerCompanyId'] ?? []), ...[Validators.required]]),
			'customerCharge': new UntypedFormControl(0, [...(validators['customerCharge'] ?? []), ...[Validators.required]]),
			'baseRate1000KWH': new UntypedFormControl(0, [...(validators['baseRate1000KWH'] ?? []), ...[Validators.required]]),
			'baseRate1200KWH': new UntypedFormControl(0, [...(validators['baseRate1200KWH'] ?? []), ...[Validators.required]]),
			'baseRate2500KWH': new UntypedFormControl(0, [...(validators['baseRate2500KWH'] ?? []), ...[Validators.required]]),
			'baseRate750KWH': new UntypedFormControl(0, [...(validators['baseRate750KWH'] ?? []), ...[Validators.required]]),
			'baseRate1500KWH': new UntypedFormControl(0, [...(validators['baseRate1500KWH'] ?? []), ...[Validators.required]]),
			'baseRate30KW6000KWH': new UntypedFormControl(0, [...(validators['baseRate30KW6000KWH'] ?? []), ...[Validators.required]]),
			'baseRate40KW10000KWH': new UntypedFormControl(0, [...(validators['baseRate40KW10000KWH'] ?? []), ...[Validators.required]]),
			'baseRate75KW15000KWH': new UntypedFormControl(0, [...(validators['baseRate75KW15000KWH'] ?? []), ...[Validators.required]]),
			'baseRate75KW30000KWH': new UntypedFormControl(0, [...(validators['baseRate75KW30000KWH'] ?? []), ...[Validators.required]]),
			'baseRate150KW30000KWH': new UntypedFormControl(0, [...(validators['baseRate150KW30000KWH'] ?? []), ...[Validators.required]]),
			'baseRate150KW60000KWH': new UntypedFormControl(0, [...(validators['baseRate150KW60000KWH'] ?? []), ...[Validators.required]]),
			'baseRate300KW60000KWH': new UntypedFormControl(0, [...(validators['baseRate300KW60000KWH'] ?? []), ...[Validators.required]]),
			'baseRate300KW1200000KWH': new UntypedFormControl(0, [...(validators['baseRate300KW1200000KWH'] ?? []), ...[Validators.required]]),
			'baseRate500KW100000KWH': new UntypedFormControl(0, [...(validators['baseRate500KW100000KWH'] ?? []), ...[Validators.required]]),
			'baseRate500KW200000KWH': new UntypedFormControl(0, [...(validators['baseRate500KW200000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj1000KWH': new UntypedFormControl(0, [...(validators['fuelAdj1000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj1200KWH': new UntypedFormControl(0, [...(validators['fuelAdj1200KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj2500KWH': new UntypedFormControl(0, [...(validators['fuelAdj2500KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj750KWH': new UntypedFormControl(0, [...(validators['fuelAdj750KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj1500KWH': new UntypedFormControl(0, [...(validators['fuelAdj1500KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj30KW6000KWH': new UntypedFormControl(0, [...(validators['fuelAdj30KW6000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj40KW10000KWH': new UntypedFormControl(0, [...(validators['fuelAdj40KW10000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj75KW15000KWH': new UntypedFormControl(0, [...(validators['fuelAdj75KW15000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj75KW30000KWH': new UntypedFormControl(0, [...(validators['fuelAdj75KW30000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj150KW30000KWH': new UntypedFormControl(0, [...(validators['fuelAdj150KW30000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj150KW60000KWH': new UntypedFormControl(0, [...(validators['fuelAdj150KW60000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj300KW60000KWH': new UntypedFormControl(0, [...(validators['fuelAdj300KW60000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj300KW1200000KWH': new UntypedFormControl(0, [...(validators['fuelAdj300KW1200000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj500KW100000KWH': new UntypedFormControl(0, [...(validators['fuelAdj500KW100000KWH'] ?? []), ...[Validators.required]]),
			'fuelAdj500KW200000KWH': new UntypedFormControl(0, [...(validators['fuelAdj500KW200000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening1000KWH': new UntypedFormControl(0, [...(validators['stormHardening1000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening1200KWH': new UntypedFormControl(0, [...(validators['stormHardening1200KWH'] ?? []), ...[Validators.required]]),
			'stormHardening2500KWH': new UntypedFormControl(0, [...(validators['stormHardening2500KWH'] ?? []), ...[Validators.required]]),
			'stormHardening750KWH': new UntypedFormControl(0, [...(validators['stormHardening750KWH'] ?? []), ...[Validators.required]]),
			'stormHardening1500KWH': new UntypedFormControl(0, [...(validators['stormHardening1500KWH'] ?? []), ...[Validators.required]]),
			'stormHardening30KW6000KWH': new UntypedFormControl(0, [...(validators['stormHardening30KW6000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening40KW10000KWH': new UntypedFormControl(0, [...(validators['stormHardening40KW10000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening75KW15000KWH': new UntypedFormControl(0, [...(validators['stormHardening75KW15000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening75KW30000KWH': new UntypedFormControl(0, [...(validators['stormHardening75KW30000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening150KW30000KWH': new UntypedFormControl(0, [...(validators['stormHardening150KW30000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening150KW60000KWH': new UntypedFormControl(0, [...(validators['stormHardening150KW60000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening300KW60000KWH': new UntypedFormControl(0, [...(validators['stormHardening300KW60000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening300KW1200000KWH': new UntypedFormControl(0, [...(validators['stormHardening300KW1200000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening500KW100000KWH': new UntypedFormControl(0, [...(validators['stormHardening500KW100000KWH'] ?? []), ...[Validators.required]]),
			'stormHardening500KW200000KWH': new UntypedFormControl(0, [...(validators['stormHardening500KW200000KWH'] ?? []), ...[Validators.required]]),
			'canEdit': new UntypedFormControl(false, [...(validators['canEdit'] ?? []), ...[]]),
			'yearMonth': new UntypedFormControl(null, [...(validators['yearMonth'] ?? []), ...[]]),
			'utilityProvider': new UntypedFormControl(null, [...(validators['utilityProvider'] ?? []), ...[]]),
			'submittedBy': new UntypedFormControl(null, [...(validators['submittedBy'] ?? []), ...[]]),
			'userEmail': new UntypedFormControl(null, [...(validators['userEmail'] ?? []), ...[]]),
			'isInvestorOwned': new UntypedFormControl(false, [...(validators['isInvestorOwned'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): BillComparisonFormVmFromFg {
		return new BillComparisonFormVmFromFg(fg);
	}
}

export class BillComparisonFormVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get providerCompanyId(): number {
		return this.fg.get('providerCompanyId').value;
	}
	set providerCompanyId(val) {
		this.fg.get('providerCompanyId').setValue(val);
	}

	get customerCharge(): number {
		return this.fg.get('customerCharge').value;
	}
	set customerCharge(val) {
		this.fg.get('customerCharge').setValue(val);
	}

	get baseRate1000KWH(): number {
		return this.fg.get('baseRate1000KWH').value;
	}
	set baseRate1000KWH(val) {
		this.fg.get('baseRate1000KWH').setValue(val);
	}

	get baseRate1200KWH(): number {
		return this.fg.get('baseRate1200KWH').value;
	}
	set baseRate1200KWH(val) {
		this.fg.get('baseRate1200KWH').setValue(val);
	}

	get baseRate2500KWH(): number {
		return this.fg.get('baseRate2500KWH').value;
	}
	set baseRate2500KWH(val) {
		this.fg.get('baseRate2500KWH').setValue(val);
	}

	get baseRate750KWH(): number {
		return this.fg.get('baseRate750KWH').value;
	}
	set baseRate750KWH(val) {
		this.fg.get('baseRate750KWH').setValue(val);
	}

	get baseRate1500KWH(): number {
		return this.fg.get('baseRate1500KWH').value;
	}
	set baseRate1500KWH(val) {
		this.fg.get('baseRate1500KWH').setValue(val);
	}

	get baseRate30KW6000KWH(): number {
		return this.fg.get('baseRate30KW6000KWH').value;
	}
	set baseRate30KW6000KWH(val) {
		this.fg.get('baseRate30KW6000KWH').setValue(val);
	}

	get baseRate40KW10000KWH(): number {
		return this.fg.get('baseRate40KW10000KWH').value;
	}
	set baseRate40KW10000KWH(val) {
		this.fg.get('baseRate40KW10000KWH').setValue(val);
	}

	get baseRate75KW15000KWH(): number {
		return this.fg.get('baseRate75KW15000KWH').value;
	}
	set baseRate75KW15000KWH(val) {
		this.fg.get('baseRate75KW15000KWH').setValue(val);
	}

	get baseRate75KW30000KWH(): number {
		return this.fg.get('baseRate75KW30000KWH').value;
	}
	set baseRate75KW30000KWH(val) {
		this.fg.get('baseRate75KW30000KWH').setValue(val);
	}

	get baseRate150KW30000KWH(): number {
		return this.fg.get('baseRate150KW30000KWH').value;
	}
	set baseRate150KW30000KWH(val) {
		this.fg.get('baseRate150KW30000KWH').setValue(val);
	}

	get baseRate150KW60000KWH(): number {
		return this.fg.get('baseRate150KW60000KWH').value;
	}
	set baseRate150KW60000KWH(val) {
		this.fg.get('baseRate150KW60000KWH').setValue(val);
	}

	get baseRate300KW60000KWH(): number {
		return this.fg.get('baseRate300KW60000KWH').value;
	}
	set baseRate300KW60000KWH(val) {
		this.fg.get('baseRate300KW60000KWH').setValue(val);
	}

	get baseRate300KW1200000KWH(): number {
		return this.fg.get('baseRate300KW1200000KWH').value;
	}
	set baseRate300KW1200000KWH(val) {
		this.fg.get('baseRate300KW1200000KWH').setValue(val);
	}

	get baseRate500KW100000KWH(): number {
		return this.fg.get('baseRate500KW100000KWH').value;
	}
	set baseRate500KW100000KWH(val) {
		this.fg.get('baseRate500KW100000KWH').setValue(val);
	}

	get baseRate500KW200000KWH(): number {
		return this.fg.get('baseRate500KW200000KWH').value;
	}
	set baseRate500KW200000KWH(val) {
		this.fg.get('baseRate500KW200000KWH').setValue(val);
	}

	get fuelAdj1000KWH(): number {
		return this.fg.get('fuelAdj1000KWH').value;
	}
	set fuelAdj1000KWH(val) {
		this.fg.get('fuelAdj1000KWH').setValue(val);
	}

	get fuelAdj1200KWH(): number {
		return this.fg.get('fuelAdj1200KWH').value;
	}
	set fuelAdj1200KWH(val) {
		this.fg.get('fuelAdj1200KWH').setValue(val);
	}

	get fuelAdj2500KWH(): number {
		return this.fg.get('fuelAdj2500KWH').value;
	}
	set fuelAdj2500KWH(val) {
		this.fg.get('fuelAdj2500KWH').setValue(val);
	}

	get fuelAdj750KWH(): number {
		return this.fg.get('fuelAdj750KWH').value;
	}
	set fuelAdj750KWH(val) {
		this.fg.get('fuelAdj750KWH').setValue(val);
	}

	get fuelAdj1500KWH(): number {
		return this.fg.get('fuelAdj1500KWH').value;
	}
	set fuelAdj1500KWH(val) {
		this.fg.get('fuelAdj1500KWH').setValue(val);
	}

	get fuelAdj30KW6000KWH(): number {
		return this.fg.get('fuelAdj30KW6000KWH').value;
	}
	set fuelAdj30KW6000KWH(val) {
		this.fg.get('fuelAdj30KW6000KWH').setValue(val);
	}

	get fuelAdj40KW10000KWH(): number {
		return this.fg.get('fuelAdj40KW10000KWH').value;
	}
	set fuelAdj40KW10000KWH(val) {
		this.fg.get('fuelAdj40KW10000KWH').setValue(val);
	}

	get fuelAdj75KW15000KWH(): number {
		return this.fg.get('fuelAdj75KW15000KWH').value;
	}
	set fuelAdj75KW15000KWH(val) {
		this.fg.get('fuelAdj75KW15000KWH').setValue(val);
	}

	get fuelAdj75KW30000KWH(): number {
		return this.fg.get('fuelAdj75KW30000KWH').value;
	}
	set fuelAdj75KW30000KWH(val) {
		this.fg.get('fuelAdj75KW30000KWH').setValue(val);
	}

	get fuelAdj150KW30000KWH(): number {
		return this.fg.get('fuelAdj150KW30000KWH').value;
	}
	set fuelAdj150KW30000KWH(val) {
		this.fg.get('fuelAdj150KW30000KWH').setValue(val);
	}

	get fuelAdj150KW60000KWH(): number {
		return this.fg.get('fuelAdj150KW60000KWH').value;
	}
	set fuelAdj150KW60000KWH(val) {
		this.fg.get('fuelAdj150KW60000KWH').setValue(val);
	}

	get fuelAdj300KW60000KWH(): number {
		return this.fg.get('fuelAdj300KW60000KWH').value;
	}
	set fuelAdj300KW60000KWH(val) {
		this.fg.get('fuelAdj300KW60000KWH').setValue(val);
	}

	get fuelAdj300KW1200000KWH(): number {
		return this.fg.get('fuelAdj300KW1200000KWH').value;
	}
	set fuelAdj300KW1200000KWH(val) {
		this.fg.get('fuelAdj300KW1200000KWH').setValue(val);
	}

	get fuelAdj500KW100000KWH(): number {
		return this.fg.get('fuelAdj500KW100000KWH').value;
	}
	set fuelAdj500KW100000KWH(val) {
		this.fg.get('fuelAdj500KW100000KWH').setValue(val);
	}

	get fuelAdj500KW200000KWH(): number {
		return this.fg.get('fuelAdj500KW200000KWH').value;
	}
	set fuelAdj500KW200000KWH(val) {
		this.fg.get('fuelAdj500KW200000KWH').setValue(val);
	}

	get stormHardening1000KWH(): number {
		return this.fg.get('stormHardening1000KWH').value;
	}
	set stormHardening1000KWH(val) {
		this.fg.get('stormHardening1000KWH').setValue(val);
	}

	get stormHardening1200KWH(): number {
		return this.fg.get('stormHardening1200KWH').value;
	}
	set stormHardening1200KWH(val) {
		this.fg.get('stormHardening1200KWH').setValue(val);
	}

	get stormHardening2500KWH(): number {
		return this.fg.get('stormHardening2500KWH').value;
	}
	set stormHardening2500KWH(val) {
		this.fg.get('stormHardening2500KWH').setValue(val);
	}

	get stormHardening750KWH(): number {
		return this.fg.get('stormHardening750KWH').value;
	}
	set stormHardening750KWH(val) {
		this.fg.get('stormHardening750KWH').setValue(val);
	}

	get stormHardening1500KWH(): number {
		return this.fg.get('stormHardening1500KWH').value;
	}
	set stormHardening1500KWH(val) {
		this.fg.get('stormHardening1500KWH').setValue(val);
	}

	get stormHardening30KW6000KWH(): number {
		return this.fg.get('stormHardening30KW6000KWH').value;
	}
	set stormHardening30KW6000KWH(val) {
		this.fg.get('stormHardening30KW6000KWH').setValue(val);
	}

	get stormHardening40KW10000KWH(): number {
		return this.fg.get('stormHardening40KW10000KWH').value;
	}
	set stormHardening40KW10000KWH(val) {
		this.fg.get('stormHardening40KW10000KWH').setValue(val);
	}

	get stormHardening75KW15000KWH(): number {
		return this.fg.get('stormHardening75KW15000KWH').value;
	}
	set stormHardening75KW15000KWH(val) {
		this.fg.get('stormHardening75KW15000KWH').setValue(val);
	}

	get stormHardening75KW30000KWH(): number {
		return this.fg.get('stormHardening75KW30000KWH').value;
	}
	set stormHardening75KW30000KWH(val) {
		this.fg.get('stormHardening75KW30000KWH').setValue(val);
	}

	get stormHardening150KW30000KWH(): number {
		return this.fg.get('stormHardening150KW30000KWH').value;
	}
	set stormHardening150KW30000KWH(val) {
		this.fg.get('stormHardening150KW30000KWH').setValue(val);
	}

	get stormHardening150KW60000KWH(): number {
		return this.fg.get('stormHardening150KW60000KWH').value;
	}
	set stormHardening150KW60000KWH(val) {
		this.fg.get('stormHardening150KW60000KWH').setValue(val);
	}

	get stormHardening300KW60000KWH(): number {
		return this.fg.get('stormHardening300KW60000KWH').value;
	}
	set stormHardening300KW60000KWH(val) {
		this.fg.get('stormHardening300KW60000KWH').setValue(val);
	}

	get stormHardening300KW1200000KWH(): number {
		return this.fg.get('stormHardening300KW1200000KWH').value;
	}
	set stormHardening300KW1200000KWH(val) {
		this.fg.get('stormHardening300KW1200000KWH').setValue(val);
	}

	get stormHardening500KW100000KWH(): number {
		return this.fg.get('stormHardening500KW100000KWH').value;
	}
	set stormHardening500KW100000KWH(val) {
		this.fg.get('stormHardening500KW100000KWH').setValue(val);
	}

	get stormHardening500KW200000KWH(): number {
		return this.fg.get('stormHardening500KW200000KWH').value;
	}
	set stormHardening500KW200000KWH(val) {
		this.fg.get('stormHardening500KW200000KWH').setValue(val);
	}

	get canEdit(): boolean {
		return this.fg.get('canEdit').value;
	}
	set canEdit(val) {
		this.fg.get('canEdit').setValue(val);
	}

	get yearMonth(): string {
		return this.fg.get('yearMonth').value;
	}
	set yearMonth(val) {
		this.fg.get('yearMonth').setValue(val);
	}

	get utilityProvider(): string {
		return this.fg.get('utilityProvider').value;
	}
	set utilityProvider(val) {
		this.fg.get('utilityProvider').setValue(val);
	}

	get submittedBy(): string {
		return this.fg.get('submittedBy').value;
	}
	set submittedBy(val) {
		this.fg.get('submittedBy').setValue(val);
	}

	get userEmail(): string {
		return this.fg.get('userEmail').value;
	}
	set userEmail(val) {
		this.fg.get('userEmail').setValue(val);
	}

	get isInvestorOwned(): boolean {
		return this.fg.get('isInvestorOwned').value;
	}
	set isInvestorOwned(val) {
		this.fg.get('isInvestorOwned').setValue(val);
	}
}
